
import React, { useEffect, useState } from "react";
import {
  Link,
  Routes,
  Route,
  useNavigate,
  NavLink,
} from "react-router-dom";

import {
  FiLogOut,
  FiMenu,
  FiX,
} from "react-icons/fi";

import logo from "../assets/logo.png";

import Dashboard from "../screens/admin/Dashboard";
import Librarians from "../screens/admin/Librarians";
import ManageOrders from "../screens/admin/ManageOrders";
import Staff from "../screens/admin/Staff";
import Profile from "../screens/admin/AdminProfile";

import "./AdminLayout.css";

const AdminLayout = () => {

  const navigate = useNavigate();

  const [menuOpen, setMenuOpen] = useState(false);


  // =========================
  // CHECK LOGIN
  // =========================

  useEffect(() => {

    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/login", { replace: true });
    }

  }, [navigate]);


  // =========================
  // LOGOUT
  // =========================

  const handleLogout = () => {

    localStorage.clear();
    sessionStorage.clear();

    setMenuOpen(false);

    navigate("/login", { replace: true });

  };


  // =========================
  // CLOSE MENU
  // =========================

  const closeMenu = () => {
    setMenuOpen(false);
  };


  return (

    <div className="admin-layout">


      {/* =========================
          NAVBAR
      ========================= */}

      <header className="admin-navbar">


        {/* LOGO */}

        <Link
          to="/admin"
          className="admin-logo-container"
          onClick={closeMenu}
          style={{
            textDecoration: "none",
            color: "inherit",
          }}
        >

          <img
            src={logo}
            alt="Ghalib Library"
            className="admin-logo-image"
          />

          <div>

            <div className="admin-logo">
              Ghalib Library
            </div>

            <div className="admin-logo-sub">
              Library Management System
            </div>

          </div>

        </Link>


        {/* =========================
            DESKTOP NAVIGATION
        ========================= */}

        <nav className="admin-nav-links">


          <NavLink
            to="/admin"
            end
            className={({ isActive }) =>
              `admin-nav-link ${isActive ? "active" : ""}`
            }
          >
            Dashboard
          </NavLink>


          <NavLink
            to="/admin/manageorders"
            className={({ isActive }) =>
              `admin-nav-link ${isActive ? "active" : ""}`
            }
          >
            Orders
          </NavLink>


          <NavLink
            to="/admin/staff"
            className={({ isActive }) =>
              `admin-nav-link ${isActive ? "active" : ""}`
            }
          >
            Staff
          </NavLink>


          <NavLink
            to="/admin/librarians"
            className={({ isActive }) =>
              `admin-nav-link ${isActive ? "active" : ""}`
            }
          >
            Librarians
          </NavLink>


          <NavLink
            to="/admin/profile"
            className={({ isActive }) =>
              `admin-nav-link ${isActive ? "active" : ""}`
            }
          >
            Admin Profile
          </NavLink>


        </nav>


        {/* =========================
            DESKTOP LOGOUT
        ========================= */}

        <button
          onClick={handleLogout}
          className="admin-logout"
        >

          <FiLogOut style={{ marginRight: "8px" }} />

          Logout

        </button>


        {/* =========================
            MOBILE MENU BUTTON
        ========================= */}

        <button
          className="admin-menu-button"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >

          {menuOpen ? <FiX /> : <FiMenu />}

        </button>


        {/* =========================
            MOBILE MENU
        ========================= */}

        {menuOpen && (

          <div className="admin-mobile-menu">


            <NavLink
              to="/admin"
              end
              onClick={closeMenu}
              className={({ isActive }) =>
                `admin-mobile-link ${isActive ? "active" : ""}`
              }
            >
              Dashboard
            </NavLink>


            <NavLink
              to="/admin/manageorders"
              onClick={closeMenu}
              className={({ isActive }) =>
                `admin-mobile-link ${isActive ? "active" : ""}`
              }
            >
              Orders
            </NavLink>


            <NavLink
              to="/admin/staff"
              onClick={closeMenu}
              className={({ isActive }) =>
                `admin-mobile-link ${isActive ? "active" : ""}`
              }
            >
              Staff
            </NavLink>


            <NavLink
              to="/admin/librarians"
              onClick={closeMenu}
              className={({ isActive }) =>
                `admin-mobile-link ${isActive ? "active" : ""}`
              }
            >
              Librarians
            </NavLink>


            <NavLink
              to="/admin/profile"
              onClick={closeMenu}
              className={({ isActive }) =>
                `admin-mobile-link ${isActive ? "active" : ""}`
              }
            >
              Admin Profile
            </NavLink>


            <button
              onClick={handleLogout}
              className="admin-mobile-logout"
            >

              <FiLogOut style={{ marginRight: "8px" }} />

              Logout

            </button>


          </div>

        )}

      </header>


      {/* =========================
          PAGE CONTENT
      ========================= */}

      <main className="admin-content">

        <Routes>

          <Route
            path="/"
            element={<Dashboard />}
          />

          <Route
            path="manageorders"
            element={<ManageOrders />}
          />

          <Route
            path="staff"
            element={<Staff />}
          />

          <Route
            path="librarians"
            element={<Librarians />}
          />

          <Route
            path="profile"
            element={<Profile />}
          />

        </Routes>

      </main>


      {/* =========================
          FOOTER
      ========================= */}

      <footer className="admin-footer">

        <div className="admin-footer-container">


          {/* ABOUT */}

          <div className="admin-footer-section">

            <h3>
              📚 Ghalib Library
            </h3>

            <p>
              Empowering learning through books,
              knowledge, and digital resources.
            </p>

          </div>


          {/* QUICK LINKS */}

          <div className="admin-footer-section">

            <h3>
              Quick Links
            </h3>

            <Link
              to="/admin"
              className="admin-footer-link"
            >
              Dashboard
            </Link>

            <Link
              to="/admin/manageorders"
              className="admin-footer-link"
            >
              Manage Orders
            </Link>

            <Link
              to="/admin/staff"
              className="admin-footer-link"
            >
              Manage Staff
            </Link>

            <Link
              to="/admin/librarians"
              className="admin-footer-link"
            >
              Librarians
            </Link>

            <Link
              to="/admin/profile"
              className="admin-footer-link"
            >
              Settings
            </Link>

          </div>


          {/* CONTACT */}

          <div className="admin-footer-section">
     <h3>
              Contact
            </h3>

            <p>
              📍{" "}
              <a
                href="https://maps.app.goo.gl/PQHPvX3exzVU9xiX6"
                target="_blank"
                rel="noreferrer"
                className="footer-link"
              >
                Ghalib Library Location
              </a>
            </p>

            <p>
              📞 (021) 33517270
            </p>

            <p>
              📧 idaraeyyadgareghalib@gmail.com
            </p>

            <p>
              🕘 Mon - Fri | 3:00PM-7:30PM
            </p>

          </div>

        </div>


        <hr className="admin-footer-line" />


        <p className="admin-copyright">

          © {new Date().getFullYear()} Ghalib Library.
          All Rights Reserved.

        </p>

      </footer>

    </div>
  );
};

export default AdminLayout;